import React from 'react'
import * as Sentry from '@sentry/react'

import { ERROR_TYPE_ENUM } from '@/services/sentry/constants'

class ErrorBoundary extends React.Component {
  componentDidCatch(error) {
    Sentry.captureException(error, (scope) => {
      scope.setTag('type', ERROR_TYPE_ENUM.RENDER)
      scope.setTag('errorType', error.name)
      return scope
    })
  }

  render() {
    const { children } = this.props
    return <>{children}</>
  }
}

export default ErrorBoundary
